import React, { PureComponent } from 'react';
import { type Props } from './types';
import type UIAnalyticsEvent from '@atlaskit/analytics-next/UIAnalyticsEvent';
import { type SpacePickerOptionValue } from './space-picker/types';
import { fireUIAnalytics } from '@atlassian/analytics-bridge';

class Content extends PureComponent<Props> {
	render() {
		const { SpacePicker, CreateSpaceLink, onCreateSpace, onSpaceSelected } = this.props;

		return (
			<div>
				<SpacePicker
					onSelected={(value: SpacePickerOptionValue, analyticsEvent: UIAnalyticsEvent) => {
						fireUIAnalytics(analyticsEvent, 'spaceSelectedSpacePicker', {
							isPageSelected: value.isPage,
						});
						onSpaceSelected(value);
					}}
				/>
				<CreateSpaceLink
					onCreateSpace={(analyticsEvent: UIAnalyticsEvent) => {
						fireUIAnalytics(analyticsEvent, 'createdSpaceButton');
						onCreateSpace();
					}}
				/>
			</div>
		);
	}
}

export default Content;
